export default "__VITE_ASSET__BmqSOPSH__"